import {
  FaFacebookF,
  FaTwitter,
  FaLinkedinIn,
  FaInstagram,
} from 'react-icons/fa';
import { AiFillRightCircle } from 'react-icons/ai';

const Footer = () => {
  const handleSubmit = (event) => {
    event.preventDefault();
  };
  return (
    <>
      <hr className='w-full' />
      <footer className='footerSec DBlock pt-8 px-6 sm:px-10'>
        <div className='max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6'>
          <div>
            <img src='/assets/svgs/logo.svg' alt='footerLogo' />
            <h2 className='font-bold text-sm uppercase pb-2 pt-5'>
              be our partner
            </h2>
            <p className='text-eventGray font-normal text-sm'>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit.Nullam
              Lorem ipsum dolor sit amet,
            </p>
          </div>
          <div>
            <h2 className='font-bold text-sm uppercase pb-4'>contact:</h2>
            <p className='text-eventGray font-normal text-sm'>
              <span className='font-bold text-sm text-black pr-1 sm:inline-block block'>
                Address:
              </span>
              4 Shannan Road, GOR 1 Lahore, Pakistan
            </p>
            <p className='text-eventGray font-normal text-sm py-3'>
              <span className='font-bold text-sm text-black pr-1 sm:inline-block block'>
                Email:
              </span>
              info@js.com.pk
            </p>
            <p className='text-eventGray font-normal text-sm'>
              <span className='font-bold text-sm text-black pr-1 sm:inline-block block'>
                Phone:
              </span>{' '}
              04232560856, 04232560857, <br />
              0300 4368333
            </p>
          </div>
          <div>
            <h2 className='font-bold text-sm uppercase pb-4'>location:</h2>
            <iframe
              className='border-none rounded-2xl'
              src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3400.4034145286128!2d74.34206211434146!3d31.540541581362927!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x391904e82b6c347b%3A0x52071049dac6d258!2s4%20Shannan%20Road%2C%20G.O.R.%20-%20I%2C%20Lahore%2C%20Punjab%2054000%2C%20Pakistan!5e0!3m2!1sen!2s!4v1668712519652!5m2!1sen!2s'
              width='100%'
              height='150'
              loading='lazy'></iframe>
          </div>
          <div>
            <h2 className='dashBorder font-bold text-sm uppercase pb-4'>
              Newsletter:
            </h2>
            <form onSubmit={handleSubmit}>
              <label className='relative w-64 md:w-auto'>
                <input
                  className='border text-sm border-gray-300 rounded-full pr-10 pl-3 py-1.5'
                  type='email'
                  name='email'
                  placeholder='johndoe@shuffle.dev'
                  required
                />
                <button type='submit' className='absolute right-2 top-0'>
                  <AiFillRightCircle size={25} fill='#F6BC4E' />
                </button>
              </label>
            </form>
            <h2 className='dashBorder font-bold text-sm uppercase py-4'>
              follow us on:
            </h2>
            <ul className='flex items-center gap-4 text-eventLightYellow'>
              <li className='text-lg sm:text-xl'>
                <a href='#'>
                  <FaFacebookF />
                </a>
              </li>
              <li className='text-lg sm:text-xl'>
                <a href='#'>
                  <FaTwitter />
                </a>
              </li>
              <li className='text-lg sm:text-xl'>
                <a href='#'>
                  <FaLinkedinIn />
                </a>
              </li>
              <li className='text-lg sm:text-xl'>
                <a href='#'>
                  <FaInstagram />
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className='max-w-5xl mx-auto border-t-2 mt-5 sm:mt-8 pb-2'>
          <p className='text-center text-eventGray text-sm pt-2 sm:pt-5'>
            Copyright © 2022 Avi Yansah
          </p>
        </div>
      </footer>
    </>
  );
};

export default Footer;
